import * as React from 'react';
import { Space } from 'antd';
import { PanelWrapper } from './styled';
import { FlexFill } from '@components/common/Utils/Layout';
import { useAtom } from 'jotai';
import DebugAtoms from '../atoms/Debug';
import { tid } from '@utils/test';
import Toolbar from './Toolbar';
import { activeToolAtom } from '@src/components/metrics-panel-hz/atoms';

function ControlPanel() {
  const [activeTool, setActiveTool] = useAtom(activeToolAtom);

  return (
    <PanelWrapper {...tid('controls')}>
      <DebugAtoms />
      <FlexFill />
      <Space>
        <Toolbar activeTool={activeTool} setActiveTool={setActiveTool} />
      </Space>
    </PanelWrapper>
  );
}

export default ControlPanel;
